import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useReactToPrint } from "react-to-print";
import QRCode from "react-qr-code";
import { Form, Modal,Button } from "react-bootstrap";
import Barcode from "react-barcode";
const MaterialList = () => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  localStorage.setItem("menu", "Master_BRP");
  localStorage.setItem("submenu", "Material Master");

  let userListData = useSelector((state) => state?.user.userList); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [data, setData] = useState([]);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printQuantity, setPrintQuantity] = useState(1); // Default 1 copy
  const [printType, setPrintType] = useState(""); // "BARCODE" or "QR"
  const [printRowData, setPrintRowData] = useState(null); // Selected row data

  const qrCodeRef = useRef();
  const barcodeRef = useRef();

  const handlePrintQr = useReactToPrint({
    contentRef: qrCodeRef,
    documentTitle: "QR_Print",
    onAfterPrint: () => setShowPrintModal(false),
  });

  const openPrintModal = (row, type) => {
    setPrintRowData(row);
    setPrintType(type); // 'BARCODE' or 'QR'
    setPrintQuantity(1); // Reset to 1 every time
    setShowPrintModal(true);
  };

  const PrintableQrcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    const qrValue = `
      Code: ${data.materialCode}
      MRP: ${data.mrPrice} INR
      Barcode ID: ${data.barcode}
    `;

    return (
      <div ref={ref} style={{ padding: "20px", width: "100%" }}>
        {/* Container flex-wrap tho unte items automatic ga kindaki vasthayi */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: "15px",
          }}
        >
          {items.map((_, index) => (
            <div
              key={index}
              style={{
                width: "30%", // 3 items per row ravali ante 30-32% ivvali
                border: "1px dashed #ccc", // Cutting ki easy ga border
                padding: "15px",
                marginBottom: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                pageBreakInside: "avoid", // Item sagam lo cut avvakunda chusukuntundi
              }}
            >
              <div style={{ textAlign: "center" }}>
                <QRCode value={qrValue} size={120} />{" "}
                {/* Size konchem taggincha fit avvadaniki */}
                <div style={{ marginTop: "10px", fontSize: "12px" }}>
                  <p className="m-0">
                    <strong>{data.materialCode}</strong>
                  </p>
                  <p className="m-0">{data.barcode}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  });

   const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
      if (!data) return null;
  
      const items = Array.from({ length: quantity > 0 ? quantity : 1 });
  
      return (
        <div ref={ref} style={{ padding: "20px", width: "100%" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              gap: "15px",
            }}
          >
            {items.map((_, index) => (
              <div
                key={index}
                style={{
                  width: "45%", // Row ki 2 Barcodes vasthayi (neat ga untundi)
                  border: "1px dashed #ccc",
                  padding: "15px",
                  marginBottom: "15px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  pageBreakInside: "avoid",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Barcode
                    value={data.barcode || "N/A"}
                    width={1.5} // Bar width konchem taggincha
                    height={60}
                    format="CODE128"
                    displayValue={true}
                    fontSize={14}
                  />
                  <div style={{ marginTop: "5px", fontSize: "12px" }}>
                    <p className="m-0">
                      <strong>{data.materialCode}</strong>
                    </p>
                    <p className="m-0">MRP: {data.mrPrice}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    });

  
  const handleFinalPrint = () => {
    if (printType === "BARCODE") {
      handlePrintBarcode();
    } else if (printType === "QR") {
      handlePrintQr();
    }
  };

    // React-to-print hooks
    const handlePrintBarcode = useReactToPrint({
      contentRef: barcodeRef,
      documentTitle: "Barcode_Print",
      onAfterPrint: () => setShowPrintModal(false), // Print ayyaka modal close
    });
  

  const materialMasterData = [
    {
      sNo: 1,
      materialCode: "FG005",
      materialDescription: "Manufactured Sand(U) 0-4.76mm",
      materialGroup: "RM",
      uoM: "Ton",
      plantName: "Barathi",
    },
    {
      sNo: 2,
      materialCode: "FG002",
      materialDescription: "Aggregates 20mm",
      materialGroup: "RM",
      uoM: "Ton",
      plantName: "Barathi",
    },
  ];

  const navigateCreateMaterial = () => {
    navigate(CustomerConstants.CUSTOMER_V1_MATERIAL_MASTER_CREATION);
  };

  // const detailedPage = () => {
  //   //dispatch(addUserID(userId));
  //   navigate(Constants.CUSTOMER_V1_MATERIAL_MASTER_DETAILS);
  // };

  const userListColInfo = [
    {
      name: "S no",
      selector: (row) => row.sNo,
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 fw-bold">{row.sNo}</span>,
      width: "120px",
    },
    {
      name: "Material Code",
      selector: (row) => row.materialCode,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.materialCode}</span>
      ),
      width: "150px",
    },
    {
      name: "Material Description",
      selector: (row) => row.materialDescription,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.materialDescription}</span>
      ),
      width: "160px",
    },
    {
      name: "Material Group",
      selector: (row) => row.materialGroup,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.materialGroup}</span>
      ),
      width: "150px",
    },
    {
      name: "Unit Of Measure",
      selector: (row) => row.uoM,
      sortable: true,
      cell: (row) => <span className="m-0 p-0 pt-1 fw-bold">{row.uoM}</span>,
      width: "130px",
    },
    {
      name: "Plant",
      selector: (row) => row.plantName,
      sortable: true,
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row.plantName}</span>
      ),
      width: "130px",
    },
    
    {
      name: "Barcode",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrint(row)}
          // NEW:
          onClick={() => openPrintModal(row, "BARCODE")}
          title="Print Barcode"
        >
          <i className="bi bi-upc-scan"></i>
          Print
        </button>
      ),
      width: "120px",
    },
    {
      name: "QR Code",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrintQrCode(row)}
          // NEW:
          onClick={() => openPrintModal(row, "QR")}
          title="Print QR Code"
        >
          <i className="bi bi-qr-code-scan"></i>
          Print QR
        </button>
      ),
      width: "130px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <>
          <button
            className="btn btn-danger"
            // onClick={() => removePOItemRow(row.local_id)}
          >
            <i className="bi bi-trash3"></i>
          </button>
        </>
      ),
      width: "200px",
    },
  ];

  const loadInitialSuuplierData = async () => {
    setData(materialMasterData);
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userListData]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={8} md={10} lg={10} className="mb-2">
                <h2 className="mainTitle">Material List</h2>
                <p className="subText">List of Material</p>
              </Col>
              <Col xs={4} md={2} lg={2} className="mb-2">
                <button className="btn w-full" onClick={navigateCreateMaterial}>
                  Add Material
                </button>
              </Col>
              <hr />
            </Row>

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ML</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Material List</span>
                      {/*  <span className="subHeaderTitle">
                        View of Supplier List{" "}
                      </span> */}
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={userListColInfo}
                          data={data}
                          progressPending={userListData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                      <Modal
                      show={showPrintModal}
                      onHide={() => setShowPrintModal(false)}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Print {printType === "QR" ? "QR Code" : "Barcode"}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group>
                          <Form.Label>Enter Quantity (Copies)</Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            value={printQuantity}
                            onChange={(e) =>
                              setPrintQuantity(parseInt(e.target.value) || 1)
                            }
                            autoFocus
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setShowPrintModal(false)}
                        >
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleFinalPrint}>
                          Print {printQuantity} Copies
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
       <div style={{ display: "none" }}>
        <PrintableBarcode
          ref={barcodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
        <PrintableQrcode
          ref={qrCodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
      </div>
    </main>
  );
};

export default MaterialList;
